export default __webpack_public_path__ + "dfd12caba5867a41b3af312889249388.png";